import {SeniorSidebarState, SeniorSidebarAction, SeniorSidebarActionType} from './types';

const reducer = (
  prevState: SeniorSidebarState,
  action: SeniorSidebarAction
): SeniorSidebarState => {
  switch (action.type) {
    case SeniorSidebarActionType.SET_SENIOR_LIST:
      return {
        ...prevState,
        list: action.list,
      };
    case SeniorSidebarActionType.SET_SELECTED_SENIOR:
      return {
        ...prevState,
        senior: action.senior,
      };
    case SeniorSidebarActionType.UPDATE_SENIOR_LIST:
      return {
        ...prevState,
        list: action.list,
      };
  }
};
export default reducer;
